




















































































































































































































import { Component, Provide, Vue } from 'vue-property-decorator'
import PageHeader from '@/components/PageHeader.vue'
import http from '@/http'
import _get from '@/helpers/_get'
import FundingRequestModel, {
  FundingRequestAttribute,
  FundingRequestBusinessModel,
} from '@/modules/funding-request/funding-request.model'
import FundingRequestFieldModel, {
  FundingRequestFieldAttribute,
} from '@/modules/funding-request-field/funding-request-field.model'
import IFundingRequestResponse from '@/modules/funding-request/funding-request-response.interface'
import IFundingRequestFieldResponse from '@/modules/funding-request-field/funding-request-field-response.interface'
import { FieldTypes } from '@/components/Form/FieldTypes'
import { AxiosError, AxiosResponse } from 'axios'
import { AdminRoutes } from '@/helpers/getRouteMeta'
import _ from 'lodash'
import permissions from '@/helpers/permissions'
import can from '@/helpers/can'
import { Getters } from '@/store/auth/getters'
import FormBase from '@/classes/Form/FormBase'
import UserModel, { UserAttribute } from '@/modules/user/user.model'
import Tabs from '@/components/Tabs.vue'
import ITabs from '@/interfaces/tabs'
import { businessRequiredFiles } from '@/helpers/fundingRequest'
import { IAttachment } from '@/interfaces/attachments'
import { Actions } from '@/store/global/actions'
import FinancierModel from '@/modules/financier/financier.model'
import { RoleAttribute } from '@/modules/role/role.model'

@Component({
  components: {
    PageHeader,
    Tabs,
  },
  methods: {
    _get,
    can,
  },
})
export default class BusinessFundingRequestsShow extends Vue {
  user: UserModel = this.$store.getters[Getters.getUser]
  form!: FormBase
  permissions = permissions
  fundingRequest: FundingRequestBusinessModel | null = null
  fundingRequestFields: FundingRequestFieldModel[] | null = null
  listRoute: string = AdminRoutes.businessOffersIndex
  jsonFields: FundingRequestFieldModel[] = []
  businessRequiredFiles = businessRequiredFiles

  tabs: ITabs[] = [
    {
      to: AdminRoutes.businessFundingRequestsShowTabOffers,
      title: 'Pasiūlymai',
      permissions: [permissions.fundingRequests.offers],
    },
    {
      to: AdminRoutes.businessFundingRequestsShowTabDocuments,
      title: 'Papildoma informacija',
      permissions: [permissions.businessFundingRequests.show],
    },
    {
      to: AdminRoutes.businessFundingRequestsShowTabAssignedUsers,
      title: 'Priskirti darbuotojai',
      permissions: [permissions.financiers.userFundingRequests],
    },
    {
      to: AdminRoutes.businessFundingRequestsShowTabActivityLog,
      title: 'Paraiškos veiksmų istorija',
      permissions: [permissions.activityLog.fundingRequest],
    },
    {
      to: AdminRoutes.businessFundingRequestsShowTabAssignedFinanciers,
      title: 'Paraiškos finansuotojai',
      permissions: [permissions.businessFundingRequests.getAssignedFinanciers],
    },
    {
      to: AdminRoutes.businessFundingRequestsShowTabVerifications,
      title: 'Tapatybės patvirtinimai',
      permissions: [permissions.verifications.index],
    },
  ]
  politics = {
    head_of_state:
      'Valstybės vadovas, vyriausybės vadovas, ministras, viceministras arba ministro pavaduotojas, valstybės sekretorius, parlamento, vyriausybės arba ministerijos kancleris',
    member_of_parliament: 'Parlamento narys',
    member_of_the_supreme_court:
      'Aukščiausiųjų teismų, konstitucinių teismų ar kitų aukščiausiųjų teisminių institucijų, kurių sprendimai negali būti skundžiami, narys',
    mayor_of_the_municipality: 'Savivaldybės meras, savivaldybės administracijos direktorius',
    member_of_the_board:
      'Aukščiausiosios valstybių audito ir kontrolės institucijos valdymo organo narys ar centrinio banko valdybos pirmininkas, jo pavaduotojas ar valdybos narys',
    ambassador:
      'Ambasadorius, laikinasis reikalų patikėtinis, nepaprastasis pasiuntinys ir įgaliotasis ministras ar aukšto rango ginkluotųjų pajėgų karininkas',
    member_of_a_state_owned_enterprise:
      'Valstybės įmonės, akcinės bendrovės, uždarosios akcinės bendrovės, kurių akcijos ar dalis akcijų, suteikiančių daugiau kaip 1/2 visų balsų šių bendrovių visuotiniame akcininkų susirinkime, priklauso valstybei nuosavybės teise, valdymo ar priežiūros organo narys',
    member_of_a_municipal_enterprise:
      'Savivaldybės įmonės, akcinės bendrovės, uždarosios akcinės bendrovės, kurių akcijos ar dalis akcijų, suteikiančių daugiau kaip 1/2 visų balsų šių bendrovių visuotiniame akcininkų susirinkime, priklauso savivaldybei nuosavybės teise ir kurios laikomos didelėmis įmonėmis pagal Lietuvos Respublikos įmonių finansinės atskaitomybės įstatymą, valdymo ar priežiūros organo narys',
    head_of_an_international_intergovernmental_organization:
      'Tarptautinės tarpvyriausybinės organizacijos vadovas, jo pavaduotojas, valdymo ar priežiūros organo narys',
  }

  @Provide('fundingRequest') getFundingRequest(): FundingRequestBusinessModel | null {
    return this.fundingRequest
  }

  async created(): Promise<void> {
    await this.loadFundingRequest()

    if (this.$route.name === AdminRoutes.businessFundingRequestsShow) {
      this.listRoute = AdminRoutes.businessFundingRequestsIndex
    }

    if (
      this.$route.name !== AdminRoutes.businessFundingRequestsShowTabOffers &&
      this.$route.name !== AdminRoutes.businessFundingRequestsShowTabDocuments
    ) {
      const firstTab = document.querySelector<HTMLAnchorElement>('#extraTabs a')

      if (firstTab) {
        firstTab.click()
      }
    }
  }

  goToList(): void {
    this.$router.push({ name: this.listRoute })
  }

  loadFundingRequest(): void {
    http
      .get(`/business-funding-requests/${this.$router.currentRoute.params.uuid}`)
      .then(
        (
          response: AxiosResponse<{
            funding_request: IFundingRequestResponse
            funding_request_fields: IFundingRequestFieldResponse[]
          }>,
        ) => {
          this.fundingRequestFields = response.data.funding_request_fields.map((item: IFundingRequestFieldResponse) =>
            new FundingRequestFieldModel().transform(item),
          )
          this.fundingRequest = new FundingRequestModel().transform(response.data.funding_request)
        },
      )
      .finally(this.filterJsonFields)
  }

  filterJsonFields(): void {
    if (this.fundingRequestFields) {
      this.jsonFields = this.fundingRequestFields.filter((field: FundingRequestFieldModel) => {
        return field[FundingRequestFieldAttribute.type] === 'json'
      })
    }
  }

  editFundingRequest(): void {
    this.$router.push({ name: AdminRoutes.businessFundingRequestsEdit })
  }

  downloadCompanyReport(): void {
    if (this.fundingRequest && this.fundingRequest.uuid) {
      http(`funding-requests/${this.fundingRequest.uuid}/get-company-report`, {
        responseType: 'blob',
        method: 'GET',
      })
        .then(async (response) => {
          const fileName = response.headers['content-disposition'].split('filename=')[1].replace(/['"]+/g, '')

          const blobUrl = URL.createObjectURL(response.data)

          const link = document.createElement('a')

          link.setAttribute('href', blobUrl)
          link.setAttribute('download', fileName)
          link.click()
        })
        .catch(async (error: AxiosError) => {
          if (error.response) {
            await this.$store.dispatch(Actions.showSnackbar, {
              type: 'error',
              message: error.response.data.message,
            })
          }
        })
    }
  }
  getOptionValue(optionvalue, option): string {
    const key = optionvalue[option.value]

    const opt = option.options.filter((o) => o.value === key)

    return opt[0].label
  }

  isFieldVisibleByRole(field: FundingRequestFieldModel): boolean {
    if (field[FundingRequestFieldAttribute.visibleByRoleSlug] === null) {
      return true
    }

    return field[FundingRequestFieldAttribute.visibleByRoleSlug]!.includes(
      this.user[UserAttribute.role][RoleAttribute.slug],
    )
  }

  downloadLoanDocument(): void {
    if (this.fundingRequest && this.fundingRequest.uuid) {
      http(`funding-requests/${this.fundingRequest.uuid}/get-signed-document`, {
        responseType: 'blob',
        method: 'GET',
      })
        .then(async (response) => {
          const fileName = response.headers['content-disposition'].split('filename=')[1]

          const blobUrl = URL.createObjectURL(response.data)

          const link = document.createElement('a')

          link.setAttribute('href', blobUrl)
          link.setAttribute('download', fileName)
          link.click()
        })
        .catch(async (error: AxiosError) => {
          if (error.response) {
            await this.$store.dispatch(Actions.showSnackbar, {
              type: 'error',
              message: error.response.data.message,
            })
          }
        })
    }
  }

  get canDownloadReport(): boolean {
    if (this.user[UserAttribute.isAdmin]) {
      return true
    }

    return this.user[UserAttribute.financier] instanceof FinancierModel
  }

  get recommendedDocuments(): any[] {
    return _.filter(this.fundingRequest?.attachments, (item: any) =>
      ['funding_request', 'guarantee', 'user_funding_request_documents'].includes(item.group),
    )
  }

  isSignedDocument(itemGroup): boolean {
    return ['user-signed-documents', 'old-user-signed-documents'].includes(itemGroup)
  }

  hasSignedDocuments(): any {
    if (this.fundingRequest?.offers) {
      const signedDocuments: any = []

      this.fundingRequest?.offers.forEach((item: any) => {
        if (
          item.user_signed_documents.find((documentItem) =>
            ['user-signed-documents', 'old-user-signed-documents'].includes(documentItem.group),
          )
        ) {
          signedDocuments.push(item)
        }
      })

      return signedDocuments.length > 0
    }

    return false
  }

  get businessRequiredAttachments(): any[] {
    return _.filter(this.fundingRequest?.attachments, (item: any) =>
      Object.keys(businessRequiredFiles).includes(item.group),
    )
  }

  getAttachmentsByIndex(key: string): IAttachment[] | undefined {
    if (this.fundingRequest && this.fundingRequest[FundingRequestAttribute.attachments]) {
      const attachments: IAttachment[] = this.fundingRequest[FundingRequestAttribute.attachments]

      return attachments.filter((attachment: IAttachment) => {
        return attachment.group === key
      })
    }

    return undefined
  }

  getValue(data: object, field: FundingRequestFieldModel): string | false {
    if (field.type === FieldTypes.select) {
      const found = field.options.find((option: any) => option.value === _.get(data, field.key))

      return found ? found.label : _.get(data, field.key, (field[FundingRequestFieldAttribute.show] = false))
    }

    if (field.type === 'json') {
      return (field[FundingRequestFieldAttribute.show] = false)
    }

    if (field.type === FieldTypes.checkbox) {
      return _.get(data, field.key) ? 'Taip' : 'Ne'
    }

    if (
      ['company_person_email', 'company_person_phone', 'company_phone', 'company_email'].includes(field.key) &&
      this.fundingRequest &&
      !this.fundingRequest.hasDynamicPermissions([permissions.fundingRequests.complete]) &&
      !this.user[UserAttribute.isAdmin]
    ) {
      return '*******'
    }

    if (field.type === FieldTypes.money) {
      return `${_.get(data, field.key)}€`
    }

    if (field.type === FieldTypes.months) {
      return `${_.get(data, field.key)} ${this.fundingRequest ? this.fundingRequest.period_measure : ''}`
    }

    return _.get(data, field.key) || (field[FundingRequestFieldAttribute.show] = false)
  }
}
